export const policyUseType = [
  { itemValue: 'PRIVATE', itemLabel: 'PRIVATE' },
  { itemValue: 'COMMERCIAL', itemLabel: 'COMMERCIAL' },
  { itemValue: 'BOTH', itemLabel: 'BOTH' },
];
